import { render, staticRenderFns } from "./ParserIndex.vue?vue&type=template&id=1a5a3597&scoped=true&"
import script from "./ParserIndex.vue?vue&type=script&lang=js&"
export * from "./ParserIndex.vue?vue&type=script&lang=js&"
import style0 from "./ParserIndex.vue?vue&type=style&index=0&id=1a5a3597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a3597",
  null
  
)

export default component.exports